/**
* Service Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'service-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const selectedButton = document.getElementById( 'selected-button' );
      const toggleButtons = document.querySelectorAll( '.service-tabs__toggle' );

      const initialChevron = selectedButton.querySelector( 'svg' );
      const initialText = selectedButton.textContent.trim();

      toggleButtons.forEach( ( button ) => {
        button.addEventListener( 'click', () => {
          const category = button.getAttribute( 'data-category' );
          if ( category ) {
            selectedButton.innerHTML = `${category} `;
            selectedButton.appendChild( initialChevron );
          }
        } );
      } );

      const defaultActiveButton = document.querySelector( '[data-toggle-is-active]' );
      if ( defaultActiveButton && selectedButton.textContent.trim() === initialText ) {
        selectedButton.innerHTML = `${defaultActiveButton.getAttribute( 'data-category' )} `;
        selectedButton.appendChild( initialChevron );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-tabs', COMPONENT );
} )( app );
